/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*@ngInject*/
export default function AddTemperatureCablesController($scope, $mdDialog,  $q, toast, types, $filter, agDeviceService, agTypes) {

    var vm = this;

    vm.add = add;
    vm.cancel = cancel;

    vm.currentDate = new Date();

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        createTemperatureCables().then(
            function() {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            }
        );
    }

    function createTemperatureCables() {
        var deferred = $q.defer();
        var temperatureCables = [];
        var productionDateString = $filter('date')(vm.productionDate, 'ddMMyy');
        var batchNumString = pad(vm.batchNumber, 2);
        var lineNum = angular.isDefined(vm.startLineNumber) ? vm.startLineNumber : 1;

        for (var i = lineNum; i < vm.numberOfLines + lineNum; i++) {
            var lineNumString = pad(i, 3);
            var name = agTypes.deviceNamePrefix.temperatureSensorLines + productionDateString + '-' + batchNumString + agTypes.deviceNameSuffix.temperatureSensorLines + lineNumString;
            var temperatureCable = {
                name: name,
                type: agTypes.deviceType.temperatureSensorLines,
                length: vm.length,
                sensorDistance: vm.sensorDistance,
                firstSensorOffset: vm.firstSensorOffset
            };
            temperatureCables.push(temperatureCable);
        }

        var tasks = [];
        for (i = 0; i < temperatureCables.length; i++) {
            var cable = temperatureCables[i];
            tasks.push(agDeviceService.saveDevice(cable, (error) => { toast.showError(error) }));
        }

        $q.all(tasks).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function pad(num, size) {
        var s = num+"";
        while (s.length < size) s = "0" + s;
        return s;
    }
}
